import React, { useEffect, useState } from "react";
import { OFFER_ANCHOR, CTA_TEXT } from "../../data/mock";
import { Zap } from "lucide-react";

const MobileStickyCTA = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`md:hidden fixed bottom-0 left-0 right-0 z-40 transition-transform duration-300 ${visible ? "translate-y-0" : "translate-y-full"}`}
    >
      <div className="bg-white/95 backdrop-blur border-t border-pink-200 px-3 pt-2 pb-[max(0.5rem,env(safe-area-inset-bottom))] shadow-[0_-6px_20px_rgba(236,72,153,0.15)]">
        <a href={OFFER_ANCHOR} className="block">
          <button className="w-full bg-gradient-to-b from-pink-500 to-rose-600 hover:from-pink-600 hover:to-rose-700 text-white font-black text-[14px] py-3.5 rounded-full shadow-lg flex items-center justify-center gap-2">
            <Zap className="w-4 h-4 fill-yellow-300 text-yellow-300" />
            {CTA_TEXT}
          </button>
        </a>
        <p className="text-center text-[10px] text-pink-900/60 mt-1">
          🔥 Restam apenas 5 vagas com todos os bônus grátis
        </p>
      </div>
    </div>
  );
};

export default MobileStickyCTA;
